// Connecticut College's undergraduate majors (#2748). Read on 2026-10-01 from
// the official Majors and Minors page (conncoll.edu/academics/
// majors-departments-programs/majors-and-minors/), which loads its list from
// conncoll.edu/style-assets/searchtest/index.json: every entry flagged
// "major": true is kept (42), minors-only subjects, Integrative Pathways and
// center certificates left out. Conn is a single liberal arts college with no
// separate schools, so the majors sit in one group. Conn's course catalog is
// hosted off .edu (conncoll.smartcatalogiq.com) and its .edu pages do not
// name each major's degree, so the degree is null. Names are as the page
// writes them ("Latin American And Latino Studies" included). The KB's
// majors list was the starting point; the page wins.
const majors = {
    "slug": "connecticut-college",
    "read": "2026-10-01",
    "intro": "Every subject Connecticut College lists as a major on its official Majors and Minors page. Conn's own pages do not name the degree type for each major, so none is shown. Minors, Integrative Pathways and center certificate programs are left out.",
    "groups": [
        {
            "name": "Majors",
            "source": {
                "label": "Connecticut College, Majors and Minors",
                "url": "https://www.conncoll.edu/academics/majors-departments-programs/majors-and-minors/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": null
                },
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Architectural Studies",
                    "degree": null
                },
                {
                    "name": "Art",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Sciences",
                    "degree": null
                },
                {
                    "name": "Botany",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Classics",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "East Asian Studies",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Educational Studies",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Film Studies",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Gender, Sexuality and Intersectionality Studies",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "Global Islamic Studies",
                    "degree": null
                },
                {
                    "name": "Government",
                    "degree": null
                },
                {
                    "name": "Hispanic Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Human Development",
                    "degree": null
                },
                {
                    "name": "International Relations",
                    "degree": null
                },
                {
                    "name": "Italian Studies",
                    "degree": null
                },
                {
                    "name": "Latin American And Latino Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Music Studies",
                    "degree": null
                },
                {
                    "name": "Music, Sound, and Technology",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Quantitative Economics and Econometrics",
                    "degree": null
                },
                {
                    "name": "Slavic Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": null
                },
                {
                    "name": "Theater",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
